import { getErrors } from 'selectors/errors';
import { VALIDATION_BLOCK as types } from './actionTypes';

// A blocked write (FR-5.1) is surfaced by the axios interceptor as the single global
// dialog (showValidationBlock). The interceptor rejects the promise with this shape so
// save handlers can recognise the block via isValidationBlockError() and suppress their
// own "save failed" toast — the dialog is the sole error surface. The spread keeps the
// normal empty-error shape (allErrors: []) so a form's inline alert also stays clear.
const VALIDATION_BLOCK_ERROR_FLAG = '__optimiserValidationBlock';

export const validationBlockError = () => ({
  ...getErrors([]),
  [VALIDATION_BLOCK_ERROR_FLAG]: true
});

export const isValidationBlockError = error => !!(error && error[VALIDATION_BLOCK_ERROR_FLAG]);

// Show the global blocking dialog with the given list[Violation] (FR-5.1). Dispatched
// from the axios response interceptor when a write is rejected (HTTP 400 with a body that
// is a list of { record_type, record_id, error_type, detail }).
export const showValidationBlock = violations => ({
  type: types.SHOW,
  violations
});

export const dismissValidationBlock = () => ({
  type: types.DISMISS
});
